export default {
    pending: {
        id: 1,
        text: 'Pendiente',
        type: 'warning'
    },
    active: {
        id: 2,
        text: 'Activo',
        type: 'success'
    },
    recovery: {
        id: 3,
        text: 'Recuperar',
        type: 'info'
    },
    blocked: {
        id: 4,
        text: 'Bloqueado',
        type: 'danger'
    },
    inactive: {
        id: 5,
        text: 'Inactivo',
        type: 'dark'
    },
    1: {
        id: 6,
        text: 'Información',
        type: 'info'
    },
    failure: {
        id: 7,
        text: 'Rechazado',
        type: 'danger'
    },
    success: {
        id: 8,
        text: 'Exitoso',
        type: 'success'
    },
    undefined: {
        id: 9,
        text: 'Información',
        type: 'info'
    },
    null: {
        id: 10,
        text: 'Información',
        type: 'info'
    },
};
